import type { ApiClient } from '@travel/api-client';

import type { CouponParams, CouponResponse } from '@travel/traveler-core/store/dom-coupon/types';
import { COUPON_API_ENDPOINT } from './constants';

export const getDomCouponAPI = async (
  http: ApiClient,
  params: CouponParams,
): Promise<CouponResponse> => {
  // Pass requestString as a GET parameter via values
  return http.get(COUPON_API_ENDPOINT, {
    values: {
      requestString: params.requestString,
    },
    ignoreCommonErrorHandler: true,
    customParams: { isTravelAPI: 'COUPON', credentials: 'include' },
  });
};
